'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TableHeader", {
    enumerable: true,
    get: function() {
        return TableHeader;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTableHeader = require("./useTableHeader");
const _renderTableHeader = require("./renderTableHeader");
const _useTableHeaderStylesstyles = require("./useTableHeaderStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TableHeader = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTableHeader.useTableHeader_unstable)(props, ref);
    (0, _useTableHeaderStylesstyles.useTableHeaderStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTableHeaderStyles_unstable')(state);
    return (0, _renderTableHeader.renderTableHeader_unstable)(state);
});
TableHeader.displayName = 'TableHeader';
